import script from "./SpeV2ResultTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SpeV2ResultTable.vue?vue&type=script&setup=true&lang=js"

import "./SpeV2ResultTable.vue?vue&type=style&index=0&id=585816a9&scoped=true&lang=css"
import "./SpeV2ResultTable.vue?vue&type=style&index=1&id=585816a9&lang=css"
import "./SpeV2ResultTable.vue?vue&type=style&index=2&id=585816a9&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585816a9"]])

export default __exports__